const template = document.createElement("template");

template.innerHTML = `
  <span class="has-tooltip">
    <slot></slot>
  </span>
  <style>
    .tooltip {
      position: fixed;
      padding: 12px 16px;
      background-color: #162751;
      box-shadow: 0px 0px 16px 1px rgba(0, 20, 60, 0.1);
      color: #fff;
      z-index: 11;
      display: none;
      font-family: Verdana;
      border: 1px solid rgba(150, 163, 196, 0.3);
      border-radius: 4px;
      line-height: 22px;
      max-width: 340px;
      width: max-content;
      box-sizing: border-box;
      font-size: 11px;
      text-align: left;
    }
    .tooltip.light {
      background-color: #fff;
      color: #00143C;
      border: 1px solid #ccc;
    }
    .tooltip-header {
      margin-bottom: 8px;
      font-size: 16px;
      display: flex;
      align-items: center;
      gap: 8px;
    }
    .tooltip-header-val {
      line-height: 16px;
      margin-bottom: 12px;
      white-space: normal;
    }
    .tooltip-header-icon {
      width: 16px;
      height: 16px;
    }
    .tooltip a {
      color: #00AFFF;
    }
    .tooltip-overlay {
      position: fixed;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
      background: rgba(0, 20, 60, 0.4);
      z-index: 10;
      display: none;
    }
    .icon-impact-sub {
      display: flex;
    }
  </style>
`;

class TooltipItem extends HTMLElement {
  constructor() {
    super();
    const shadow = this.attachShadow({ mode: "open" });
    shadow.append(template.content.cloneNode(true));

    this.handleTooltipClick = this.handleTooltipClick.bind(this);
  }

  static get observedAttributes() {
    return ['type', 'header-text', 'show-icon', 'link-text', 'icon', 'link-url', 'link-target', 'val', 'has-fixed-wrapper', 'position-container-class'];
  }

  connectedCallback() {
    this.addEventListener('click', (event) => {
      event.stopPropagation();
      this.showTooltip();
    });

    document.addEventListener('click', this.handleOutsideClick.bind(this));
  }

  disconnectedCallback() {
    document.removeEventListener('click', this.handleOutsideClick.bind(this));
    this.removeTooltipClickListener();
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (oldValue !== newValue) {
      this[name.replace(/-./g, x => x[1].toUpperCase())] = newValue;
    }
  }

  hideAllTooltips(currentElement) {
    document.querySelectorAll('tooltip-item').forEach(item => {
      if (item === currentElement) return;

      const tooltip = item.shadowRoot.querySelector('.tooltip');
      const tooltipBackground = item.shadowRoot.querySelector('.tooltip-overlay');
      if (tooltip) {
        tooltip.style.display = 'none';
        tooltip.remove();
        item.removeTooltipClickListener();
      }

      if (tooltipBackground) {
        tooltipBackground.style.display = 'none';
        tooltipBackground.remove();
      }
    });
  }

  showTooltip() {
    this.hideAllTooltips(this);

    let tooltip = this.shadowRoot.querySelector('.tooltip');
    let tooltipBackground = this.shadowRoot.querySelector('.tooltip-overlay');
    const positionContainerClassElement = document.getElementsByClassName(this.positionContainerClass)[0];

    if (window.innerWidth < 600 || positionContainerClassElement) {
      if (!tooltipBackground) {
        tooltipBackground = document.createElement('div');
        tooltipBackground.className = 'tooltip-overlay';
        this.shadowRoot.appendChild(tooltipBackground);
      } else {
        tooltipBackground.remove();
      }
      if (this.type === 'light') {
        tooltipBackground.style.backgroundColor = 'rgba(0, 20, 60, 0.4)';
      } else {
        tooltipBackground.style.backgroundColor = 'rgba(255, 255, 255, 0.4)';
      }
    }

    if (!tooltip) {
      tooltip = document.createElement('div');
      tooltip.className = 'tooltip ' + (this.type || 'dark');
      this.shadowRoot.appendChild(tooltip);
    } else {
      tooltip.remove();
    }

    tooltip.innerHTML = '<div class="tooltip-header-val">' + (this.val || '') + '</div>';
    const iconHtml = this.icon ||
      `<i class="icon-impact-sub">
        <svg width="16" height="16" viewBox="0 0 12 12"
          fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0_4056_12534)">
              <path
                  d="M0.75 6C0.75 3.09987 3.09987 0.75 6 0.75C8.90013 0.75 11.25 3.09987 11.25 6C11.25 8.90013 8.90013 11.25 6 11.25C3.09987 11.25 0.75 8.90013 0.75 6Z"
                  fill="url(#isc_gold_linear_gradient)"></path>
              <path d="M10.329 4.81481L7.85181 2.85461V6.77501L10.329 4.81481Z" fill="#060A2A"></path>
              <path d="M8.96467 3.95441H4.78467V5.68141H8.96467V3.95441Z" fill="#060A2A"></path>
              <path d="M1.66919 7.1864L4.14639 9.1466V5.2262L1.66919 7.1864Z" fill="#060A2A"></path>
              <path d="M3.03338 8.04663H7.21338V6.31963H3.03338V8.04663Z" fill="#060A2A"></path>
          </g>
          <defs>
              <clipPath id="clip0_4056_12534">
                  <rect width="11" height="11" fill="white" transform="translate(0.5 0.5)"></rect>
              </clipPath>
              <linearGradient id="isc_gold_linear_gradient" x1="-36.3075%" y1="-42.0999%" x2="151.3381%" y2="-55.1133%"
                gradientUnits="userSpaceOnUse">
                <stop stop-color="#BCA979" />
                <stop offset="1" stop-color="#FCE1A4" />
              </linearGradient>
          </defs>
        </svg>
      </i>`;

      const isIconAvailable = this.showIcon !== null && this.showIcon !== undefined;

      if (this.headerText || isIconAvailable) {
        const header = document.createElement("div");
        header.classList.add('tooltip-header');
        header.innerHTML = `
            ${isIconAvailable ? iconHtml : ''}
            <div class="tooltip-header-text">${this.headerText || ''}</div>
        `;
        tooltip.prepend(header);
    }

    if (this.linkText && this.linkUrl) {
      const link = document.createElement("a");
      link.href = this.linkUrl;
      link.target = this.linkTarget || '_blank';
      link.innerHTML = '<span>' + this.linkText + '</span>';
      tooltip.append(link);
    }

    tooltip.style.display = 'block';
    tooltip.addEventListener('click', this.handleTooltipClick);
    this.calculateTooltipPosition(tooltip);
    if (tooltipBackground) {
      tooltipBackground.style.display = 'block';
    }
  
  };

  calculateTooltipPosition(tooltip) {
    const elemRect = this.getBoundingClientRect();
    let tooltipWidth = tooltip.offsetWidth;
    let tooltipHeight = tooltip.offsetHeight;
    const tooltipOverlay = this.shadowRoot.querySelector('.tooltip-overlay');
    const positionContainerClassElement = document.getElementsByClassName(this.positionContainerClass)[0];
    const gap = 5;
    let left, top;
    
    // mobile view
    if (window.innerWidth < 600 || positionContainerClassElement) {
      const tooltipContainer = positionContainerClassElement ? positionContainerClassElement : document.documentElement;
      const tooltipContainerRect = tooltipContainer.getBoundingClientRect();
      tooltipWidth = tooltipContainer.offsetWidth * 0.90;
      tooltip.style.width = `${tooltipWidth}px`;
      tooltip.style.maxWidth = 'none';
      tooltipHeight = tooltip.offsetHeight;
      const distanceOfFixedHeader = tooltipContainerRect.top > 0 ? tooltipContainerRect.top : 0;
      const tooltipDownPosition = this.hasFixedWrapper ?
        this.offsetTop + elemRect.height - distanceOfFixedHeader + gap:
        elemRect.bottom - distanceOfFixedHeader + tooltipContainer.scrollTop + gap;
      const tooltipUpPosition = elemRect.top - distanceOfFixedHeader - tooltipHeight + tooltipContainer.scrollTop - gap;
      const shouldRenderTooltipUp = tooltipDownPosition + tooltipHeight > tooltipContainer.scrollHeight;

      top = shouldRenderTooltipUp ? tooltipUpPosition : tooltipDownPosition;
      left = (tooltipContainer.offsetWidth - tooltipWidth) / 2;

      if (tooltipOverlay) {
        if (shouldRenderTooltipUp) {
          const heightWithoutPadding = this.getHeightWithoutPadding(tooltip);
          tooltipOverlay.style.height = `${tooltipContainer.scrollHeight - heightWithoutPadding}px`;
        }
        else {
            tooltipOverlay.style.height = `${tooltipContainer.scrollHeight}px`;
        }
        tooltipOverlay.style.width = `${tooltipContainer.clientWidth}px`;
      }

      tooltip.style.left = `${left}px`;
      tooltip.style.top = `${this.hasFixedWrapper ? top : top - window.pageYOffset}px`;

      window.addEventListener('scroll', (event) => {
        tooltip.style.top = `${this.hasFixedWrapper ? top : top - window.pageYOffset}px`;
      });
    } else {
      //desktop view
      const headerHeight = 90;
      left = (this.hasFixedWrapper ? this.offsetLeft : elemRect.left) + (this.offsetWidth / 2) - (tooltipWidth / 2);
      top = (this.hasFixedWrapper ? this.offsetTop : elemRect.top) - tooltipHeight - gap;
      left = Math.max(gap, Math.min(left, window.innerWidth - tooltipWidth - gap));
      const shouldRenderTooltipUp = top >= headerHeight;
      const topWithWrapperOrNot = this.hasFixedWrapper ?
        this.offsetTop + elemRect.height + gap
        : elemRect.bottom + gap;
      top = shouldRenderTooltipUp ? Math.min(top, window.innerHeight - tooltipHeight - gap) : topWithWrapperOrNot;

      if (this.hasFixedWrapper) {
        tooltip.style.position = 'absolute';
      }
      tooltip.style.left = `${left}px`;
      tooltip.style.top = `${top}px`;
      let initialScrollY = window.scrollY;
      let initialScrollX = window.scrollX;

      window.addEventListener('scroll', (event) => {
        const scrollYDiff = window.scrollY - initialScrollY;
        const scrollXdiff = window.scrollX - initialScrollX;
        tooltip.style.top = `${this.hasFixedWrapper ? top : top - scrollYDiff}px`;
        tooltip.style.left = `${this.hasFixedWrapper ? left : left - scrollXdiff}px`;

      });
    }
  }

  handleTooltipClick(event) {
    event.stopPropagation();
    const tooltip = this.shadowRoot.querySelector('.tooltip');
    const tooltipBackground = this.shadowRoot.querySelector('.tooltip-overlay');
    if (tooltip) {
      tooltip.style.display = 'none';
      tooltip.remove();
      if (tooltipBackground) {
        tooltipBackground.style.display = 'none';
        tooltipBackground.remove();
      }
      this.removeTooltipClickListener();
    }
  }

  getHeightWithoutPadding(element) {
    const style = getComputedStyle(element);
    const paddingTop = parseFloat(style.paddingTop);
    const paddingBottom = parseFloat(style.paddingBottom);
    const heightWithoutPadding = element.offsetHeight - paddingTop - paddingBottom;
    return heightWithoutPadding;
  }

  removeTooltipClickListener() {
    const tooltip = this.shadowRoot.querySelector('.tooltip');
    const tooltipBackground = this.shadowRoot.querySelector('.tooltip-overlay');
    if (tooltip) {
      tooltip.removeEventListener('click', this.handleTooltipClick);
    }
    if (tooltipBackground) {
      tooltipBackground.removeEventListener('click', this.handleTooltipClick);
    }
  }

  handleOutsideClick(event) {
    const tooltip = this.shadowRoot.querySelector('.tooltip');
    const tooltipBackground = this.shadowRoot.querySelector('.tooltip-overlay');

    if (tooltip && !this.contains(event.target)) {
      tooltip.style.display = 'none';
      tooltip.remove();
      if (tooltipBackground) {
        tooltipBackground.style.display = 'none';
        tooltipBackground.remove();
      }
      this.removeTooltipClickListener();
    }
  }
}
if (!customElements.get('tooltip-item')) { customElements.define('tooltip-item', TooltipItem); }